<template>
	<div class="not-found-page">
		<h1>Pagina niet gevonden</h1>
		<RouterLink :to="{ name: 'App' }"> Terug naar home </RouterLink>
	</div>
</template>

<style lang="scss" scoped>
.not-found-page {
	padding: 28px 50px;

	a {
		margin-top: 16px;
		display: block;
	}
}
</style>
